var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.382 29.09a13.692 13.692 0 1 1-27.38 0C11.002 21.53 24.693 6 24.693 6s13.689 15.53 13.689 23.09z",
    stroke: "currentColor",
    strokeWidth: "0.04em",
    strokeMiterlimit: "0.2em"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 31.614h-.217a.744.744 0 0 1-.831-.64l-1.62-14.253a.734.734 0 0 1 .73-.813h3.639a.735.735 0 0 1 .723.813l-1.61 14.253a.745.745 0 0 1-.813.64zM24.683 36.402a1.966 1.966 0 1 0 0-3.933 1.966 1.966 0 0 0 0 3.933z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeak);
export default __webpack_public_path__ + "static/media/leak.098e55aaf01780f3509d7e63fa82b6fb.svg";
export { ForwardRef as ReactComponent };